module.exports = __webpack_public_path__ + "static/join-icon-878317927344d62e39d89d5ca4b1683f.png";